module.exports = __webpack_public_path__ + "static/media/general_background.71cabe92.svg";